import KpiCard from './KpiCard';
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import 'moment/locale/pt-br';
import { DashboardService } from './service';
import { useDashboardContext } from './Context';
import { useAuthContext } from '../../contexts/AuthContext';

const service = new DashboardService();

export const ChartVisaoGeral = () => {
    const { selectedDate, atendenteId } = useDashboardContext();
    const { user } = useAuthContext();

    const [loading, setLoading] = useState(false);
    const [dadosSemana, setDadosSemana] = useState({
        hoje: {
            totalAgendamentos: 0,
            faturamento: 0,
            atendimentosConcluidos: 0,
            comissao: 0,
        },
        semana: {
            totalAgendamentos: 0,
            faturamento: 0,
            atendimentosConcluidos: 0,
            comissao: 0,
        },
    });

    useEffect(() => {
        const load = async () => {
            try {
                setLoading(true);
                const response = await service.getVisaoGeral(selectedDate, atendenteId);
                setDadosSemana(response.data);
            } catch (e) {
                console.error('Erro ao carregar os dados da visão geral:', e);
            } finally {
                setLoading(false);
            }
        };

        load();
    }, [selectedDate, atendenteId]);

    const dataAtual = moment(selectedDate).locale('pt-br').format('dddd, D [de] MMMM');

    const inicioSemana = moment(selectedDate).startOf('week').locale('pt-br').format('dddd, D [de] MMMM');
    const fimSemana = moment(selectedDate).endOf('week').locale('pt-br').format('dddd, D [de] MMMM');

    const currency = (value: number) => value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    const periods = [
        { title: 'Dia de referência', description: dataAtual, data: dadosSemana.hoje },
        { title: 'Semana de referência', description: `${inicioSemana} — ${fimSemana}`, data: dadosSemana.semana },
    ];

    return (
        <div className={`space-y-8 ${loading ? 'opacity-50' : ''}`} aria-busy={loading}>
            {periods.map(({ title, description, data }) => (
                <section key={title}>
                    <h3>{title}</h3>
                    <p className="mt-1 mb-4 text-xs text-base-content/60">{description}</p>
                    <div className="sf-dashboard-summary-grid">
                        <KpiCard title="Agendados" value={data.totalAgendamentos} />
                        <KpiCard title="Concluídos" value={data.atendimentosConcluidos} />
                        {(user?.root || user?.admin) && <KpiCard title="Faturamento" value={currency(data.faturamento)} />}
                        <KpiCard title="Comissão" value={currency(data.comissao)} />
                    </div>
                </section>
            ))}
        </div>
    );
};
